import { render, staticRenderFns } from "./ProviderServiceForm.vue?vue&type=template&id=73eca4f8&v-if=internal&"
import script from "./ProviderServiceForm.vue?vue&type=script&lang=ts&"
export * from "./ProviderServiceForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
